import { createContext, useContext } from 'react';

/**
 * When a provider sets this context to `true`, every form field nested below
 * treats its `required` prop as `false` (no validation rule, no asterisk).
 * Defaults to `false`, so fields keep their own `required` value everywhere else.
 */
export const FieldRequiredOverrideContext = createContext(false);

/**
 * Resolves the effective `required` value for a form field, forcing it to `false`
 * when an ancestor `FieldRequiredOverrideContext` provider has disabled
 * requirements.
 *
 * @param {boolean} required - The field's own `required` prop.
 * @returns {boolean}
 */
export const useFieldRequired = (required) =>
  useContext(FieldRequiredOverrideContext) ? false : required;
